<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <div class="block-content block-content-full mt-4 mb-1">
            <table class="table table-vcenter table-striped" v-if="emailsList">
                <thead>
                    <tr>
                        <th class="text-center">{{ $t('marketing.campaigns.months') }}</th>
                        <th class="text-center">{{ $t('marketing.campaigns.emails_sent_count') }}</th>
                        <th class="text-center">{{ $t('marketing.campaigns.actions_header') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in emailsList" :key="item.month.number">
                        <td class="text-center">{{ item?.month?.name }}</td>
                        <td class="text-center">{{ item?.value?.count_emails }}</td>
                        <td class="text-center">
                            <button
                                class="btn fs-sm btn-dark px-4 rounded-8 fw-medium btn-more"
                                @click="fetchListEmails(true, item?.value?.year, item?.month?.number)"
                                :disabled="item?.value?.count_emails > 0 ? false : true"
                            >
                                {{ $t('marketing.campaigns.view_detail') }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <modal
            name="fullscreen-modal"
            width="90%"
            height="80%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="$modal.hide('fullscreen-modal')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
            <div class="email-list">
                <div class="vue-datatable ppv2-bg-white">
                    <table class="datatable">
                        <thead>
                            <tr>
                                <th class="text-center">{{ $t('marketing.campaigns.name') }}</th>
                                <th class="text-center">{{ $t('marketing.campaigns.subject_header') }}</th>
                                <th class="text-center">{{ $t('marketing.campaigns.status_header') }}</th>
                                <th class="text-center">
                                    {{ $t('marketing.campaigns.emails_count') }}
                                    <span style="color: #22bb33">({{ $t('marketing.campaigns.success') }})</span>
                                </th>
                                <th class="text-center">
                                    {{ $t('marketing.campaigns.emails_count') }}
                                    <span style="color: #bb2124">({{ $t('marketing.campaigns.failed') }})</span>
                                </th>
                                <th class="text-center">{{ $t('marketing.campaigns.sent_datetime') }}</th>
                                <th class="text-center">{{ $t('marketing.campaigns.creation_date') }}</th>
                                <th class="text-center">{{ $t('marketing.campaigns.actions_header') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in emailsListDetails" :key="item.id">
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ item.name }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ item.email_subject }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ getStatusTranslation(item.status) }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ item.count_emails ?? '-' }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ item.count_emails_failed ?? '-' }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ item.start_date ?? '-' }} {{ item.start_time ?? '--:--' }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    {{ item.created_at }}
                                </td>
                                <td
                                    :class="[
                                        index % 2 === 0 ? 'text-center text-odd bg-odd' : 'text-center text-odd ppv2-bg-none',
                                    ]"
                                >
                                    <button @click="fetchCustomersList(item?.uuid, 'success')" :disabled="!item.count_emails > 0">
                                        <i class="fas fa-users" style="color: #22bb33"></i>
                                    </button>
                                    <button
                                        @click="fetchCustomersList(item?.uuid, 'failed')"
                                        :disabled="!item.count_emails_failed > 0"
                                    >
                                        <i class="fas fa-users" style="color: #bb2124"></i>
                                    </button>
                                    <button @click="showModalHtmlContent(item?.content ?? '')" :disabled="item?.content == ''">
                                        <i class="fa fa-envelope p-2"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </modal>

        <modal
            name="show-customers-modal"
            width="85%"
            height="75%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="$modal.hide('show-customers-modal')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
            <div class="email-list">
                <div class="block-content block-content-full">
                    <bo-customer-datatable
                        :selectedCampagneUuid="selectedCampagneUuid"
                        :customersEmailsStatus="customersEmailsStatus"
                    ></bo-customer-datatable>
                </div>
            </div>
        </modal>

        <modal
            name="show-html-content-modal"
            width="85%"
            height="75%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="$modal.hide('show-html-content-modal')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
            <div class="email-list">
                <div class="block-content block-content-full">
                    <p v-html="htmlConetnt"></p>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import ApiManagerMarketing from './Api/ApiManagerMarketing.js'

export default {
    name: 'CampaingEmailList',
    components: {},
    data: () => ({
        emailsList: [],
        emailsListDetails: [],
        loading: false,
        emailId: 0,
        htmlConetnt: '',
        selectedCampagneUuid: '',
        customersEmailsStatus: '',
    }),
    methods: {
        async fetchListEmails(details = false, year = '', month = '') {
            this.loading = true

            const params = {
                ajax: true,
                details: details,
                month: month,
                year: year,
            }

            try {
                const result = await ApiManagerMarketing.fetchListEmails(params)

                if (details === true && result?.data) {
                    this.emailsListDetails = result.data
                    this.$modal.show('fullscreen-modal')
                } else {
                    this.emailsList = result.data
                }

                console.log('this.emailsList', this.emailsList)
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },

        async fetchCustomersList(campagneUuid, customersEmailsStatus = 'success') {
            this.loading = true
            this.selectedCampagneUuid = campagneUuid
            this.customersEmailsStatus = customersEmailsStatus

            console.log('this.selectedCampagneUuid', this.selectedCampagneUuid)
            console.log('this.customersEmailsStatus', this.customersEmailsStatus)

            this.$modal.show('show-customers-modal')
        },

        showContent(content) {
            if (content?.length > 50) {
                return content.substring(0, 50) + '...'
            }
            return content
        },

        showModalHtmlContent(content = '') {
            console.log('content', content)
            if (content == '') return
            this.htmlConetnt = content
            this.$modal.show('show-html-content-modal')
        },

        getStatusTranslation(status) {
            const statusMap = {
                0: 'draft',
                1: 'in_progress',
                2: 'canceled',
                3: 'finished',
                4: 'scheduled',
                5: 'failed',
            }
            const key = statusMap[status] || 'draft'
            return this.$t(`marketing.campaigns.status.${key}`)
        },
    },

    async mounted() {
        await this.fetchListEmails()
    },
}
</script>

<style scoped>
.loader-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.loader {
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #333;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.table {
    width: 100%;
    text-transform: capitalize;
}

.email-list {
    overflow-y: auto;
    height: calc(100% - 120px);
    padding: 6rem 4rem;
}

.vm--modal {
    background-color: #f8fafc !important;
    padding: 1.5rem !important;
}

.btn-exit {
    position: absolute;
    top: 10px;
    right: 16px;
    display: flex;
    width: 45px;
    height: 45px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 15px;
}

.btn-more {
    height: 40px !important;
    line-height: 25px !important;
}
</style>
